/**
 * @Author: v_jppjpeng
 * @Date: 2023-05-24 20:06:48
 * @Explain: 登录、注册、忘记密码
 */
import adminHttp from '../adminHttp';
import { HttpResponse } from '../data.d';
import http from '../http';

const MODEL = '/login';
const MODEL_INVITE = '/invite';

export default {
  // 登录
  onLogin(data: Record<any, any>) {
    return adminHttp.post(`${MODEL}/signin`, data);
  },
  // 登录 - 获取密码盐
  getPasswordSalt(data: Record<any, any>): Promise<HttpResponse> {
    return adminHttp.post(`${MODEL}/getPasswordSalt`, data);
  },
  // 注册
  onRegister(data: Record<any, any>) {
    return adminHttp.post(`${MODEL}/signup`, data);
  },
  // 重置密码
  resetPassword(data: Record<any, any>) {
    return adminHttp.post(`${MODEL}/resetPassword`, data);
  },
  // 检查用户名是否存在
  checkName(data: Record<any, any>): Promise<HttpResponse> {
    return adminHttp.post(`${MODEL}/checkNameExist`, data);
  },
  // 接受邀请
  onAcceptInvitation(data: Record<any, any>) {
    return http.post(`${MODEL_INVITE}/accept-invite`, data);
  },
  // 获取双因素信息
  getTwoFactorInfo(data: Record<any, any>) {
    return adminHttp.post(`${MODEL}/get_two_factor`, data);
  },
};
